import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { FiMessageCircle } from "react-icons/fi";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import AllProducts from "./pages/AllProducts";
import Uniforms from "./pages/Uniforms";
import UniformDetail from "./pages/UniformDetail";
import Products from "./pages/Products";
import Departments from "./pages/Departments";
import Contact from "./pages/Contact";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function WhatsAppFloat() {
  const msg = encodeURIComponent(
    "Hi Shaheen Sports! I'd like to know more about your products.",
  );
  return (
    <a
      href={`https://wa.me/++92-342-075 7213?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float"
      aria-label="WhatsApp"
    >
      <FiMessageCircle size={22} />
      <span className="wa-float__label">WhatsApp Us</span>
    </a>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />

          {/* All Products landing */}
          <Route path="/all-products" element={<AllProducts />} />

          {/* Uniforms */}
          <Route path="/uniforms" element={<Uniforms />} />
          <Route path="/uniforms/:slug" element={<UniformDetail />} />

        

          {/* Direct product categories */}
          <Route path="/products/:category" element={<Products />} />

          <Route path="/departments" element={<Departments />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
    </Router>
  );
}
